module.exports = __webpack_public_path__ + "static/media/snail.8b09e1d3.svg";